module.exports = __webpack_public_path__ + "img/r-badge-diamond.74b44837.png";